"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabTextContainer = exports.TabIconContainer = exports.StyledNavTab = exports.StyledNavTabContainer = exports.StyledComponentContainer = exports.StyledTabContainer = exports.StyledTab = exports.StyledTabContentContainer = exports.StyledSecondary = exports.TabData = exports.TopIcon = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _knotchincWebReactComponents = require("@bit/knotchinc.web-react-components.styled");

var _medal = _interopRequireDefault(require("../../assets/icons/medal.svg"));

var _medalPink = _interopRequireDefault(require("../../assets/icons/medalPink.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  line-height: 20px;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  border-radius: 100%;\n  width: 18px;\n  height: 18px;\n  overflow: hidden;\n  background: #C4C4C4;\n  margin-right: 8px;\n  float: left;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  height: 50px;\n  min-width: 200px;\n  background: ", ";\n  color: white;\n  text-align: center;\n  padding: 0 0 5px;\n  font-size: 10px;\n  line-height: 14px;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  margin-right: 12px;\n\n  @media (max-width: 1300px) {\n    min-width: 180px;\n  }\n\n  &:after {\n    border-left-color: ", ";\n    border-width: 50px 0 0 22px;\n  }\n\n  &:hover {\n    text-decoration: none;\n    background: ", ";\n    color: white;\n\n    &:after {\n      border-left-color: ", ";\n    }\n  }\n\n  &.active {\n    background: ", ";\n    color: ", ";\n\n    &:after {\n      border-left-color: ", ";\n    }\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  width: 1000px;\n  text-align: right;\n  padding-right: 6px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n  background-color: white;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  min-width: 500px;\n  overflow: hidden;\n  padding-right: 5px;\n  text-align: left;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    ", " {\n      color: ", ";\n\n      ", " {\n        background-image: url(", ");\n      }\n    }\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  ", ";\n  width: ", ";\n  max-width: 240px;\n  height: ", "px;\n  bottom: -5px;\n  margin-right: 1%;\n  background: ", ";\n  cursor: pointer;\n  color: #8894a5;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 7px;\n  z-index: ", ";\n  text-align: left;\n  padding: 0 1px 5px 26px;\n  transition: all .2s ease;\n  filter: drop-shadow(0 11px 4px rgba(0,0,0,0.1));\n  text-decoration: none;\n  white-space: nowrap;\n  font-size: 12px;\n\n  &:after {\n    content: '';\n    position: absolute;\n    right: -21px;\n    width: 0;\n    height: 0;\n    top: 3px;\n    border-style: solid;\n    border-width: ", "px 0 0 22px;\n    transition: all .2s ease;\n    border-color: transparent transparent transparent ", ";\n  }\n\n  &:hover {\n    text-decoration: none;\n    bottom: 0;\n  }\n\n  &:hover, &.active {\n    background-color: white;\n    color: #414955;\n\n    &:after {\n      border-color: transparent transparent transparent white;\n    }\n  }\n\n  &.active {\n    z-index: 3;\n  }\n\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 99%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  color: #C6C6C6;\n  width: 99%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 80%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: transparent url(", ") center center no-repeat;\n  background-size: cover;\n  width: 10px;\n  height: 10px;\n  display: inline-block;\n  margin-right: 5px;\n  vertical-align: middle;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TAB_HEIGHT = 50;

var TopIcon = _styledComponents["default"].div(_templateObject(), _medal["default"]);

exports.TopIcon = TopIcon;

var TabData = _styledComponents["default"].div(_templateObject2());

exports.TabData = TabData;

var StyledSecondary = _styledComponents["default"].div(_templateObject3());

exports.StyledSecondary = StyledSecondary;

var StyledTabContentContainer = _styledComponents["default"].div(_templateObject4());

exports.StyledTabContentContainer = StyledTabContentContainer;

var StyledTab = _styledComponents["default"].div(_templateObject5(), _knotchincWebReactComponents.contentCentered, function (_ref) {
  var maxWidth = _ref.maxWidth,
      onlyChild = _ref.onlyChild;
  return onlyChild ? '220px' : "".concat(maxWidth - 1, "%");
}, TAB_HEIGHT + 5, function (_ref2) {
  var selected = _ref2.selected,
      theme = _ref2.theme;
  return selected ? 'white' : theme.colors.offWhite;
}, function (_ref3) {
  var selected = _ref3.selected;
  return selected ? 3 : 'auto';
}, TAB_HEIGHT + 5, function (_ref4) {
  var selected = _ref4.selected,
      theme = _ref4.theme;
  return selected ? 'white' : theme.colors.offWhite;
}, function (_ref5) {
  var selected = _ref5.selected,
      theme = _ref5.theme;
  return selected && (0, _styledComponents.css)(_templateObject6(), StyledSecondary, theme.colors.palette[7], TopIcon, _medalPink["default"]);
});

exports.StyledTab = StyledTab;

var StyledTabContainer = _styledComponents["default"].div(_templateObject7());

exports.StyledTabContainer = StyledTabContainer;

var StyledComponentContainer = _styledComponents["default"].div(_templateObject8());

exports.StyledComponentContainer = StyledComponentContainer;
var StyledNavTabContainer = (0, _styledComponents["default"])(StyledTabContainer)(_templateObject9());
exports.StyledNavTabContainer = StyledNavTabContainer;
var StyledNavTab = (0, _styledComponents["default"])(StyledTab)(_templateObject10(), function (_ref6) {
  var colors = _ref6.theme.colors;
  return colors.palette[5];
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.palette[5];
}, function (_ref8) {
  var colors = _ref8.theme.colors;
  return colors.palette[5];
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.palette[5];
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.background;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.palette[5];
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.background;
});
exports.StyledNavTab = StyledNavTab;

var TabIconContainer = _styledComponents["default"].div(_templateObject11());

exports.TabIconContainer = TabIconContainer;

var TabTextContainer = _styledComponents["default"].div(_templateObject12());

exports.TabTextContainer = TabTextContainer;

//# sourceMappingURL=styled.js.map